<template>
    <li>
        <div>
          <img v-if="item.img" :src="item.img" class="mr-1" height="30px" :alt="item.title">
          <span :class="{}">{{ item.title }}</span>
          <span v-if="hasActivityData" @click="toggleActivityData" class="toggle-tree-item">[{{ isOpenActivityData ? '-' : '+' }}]</span>
          <span v-if="isFolder" @click="toggle" class="toggle-tree-item">[{{ isOpen ? '-' : '+' }}]</span>
          <span v-if="item.desc" class="icomoon-info text-success" :title="item.desc"></span>
        </div>
        <div v-show="isOpenActivityData" v-if="hasActivityData" class="table-responsive">
          <table class="table">
            <tr v-for="(activityDatumId, index) in item.activityData" :key="index" v-show="!filter || (calculations[activityDatumId].title.toLowerCase()).search(filter.toLowerCase()) > -1">
              <td>
                <div>
                  {{ calculations[activityDatumId].title }}
                  <span v-if="calculations[activityDatumId].desc" class="icomoon-info text-success ml-1" :title="calculations[activityDatumId].desc"></span>
                </div>
                <input :id="'indata_' + itemIndex + '_' + activityDatumId" type="number" class="form-control" @input="emitGhgInputEvent($event.target.value,itemIndex,activityDatumId,null,null,null,rootItemIndex)">
              </td>
              <td><span>kg CO2<span v-show="missingCH4N2O(calculations[activityDatumId].kg_CO2e_of_CH4_per_unit, calculations[activityDatumId].kg_CO2e_of_N2O_per_unit)">e</span> per unit&nbsp;<i class="icomoon-info" :title="(missingCH4N2O(calculations[activityDatumId].kg_CO2e_of_CH4_per_unit, calculations[activityDatumId].kg_CO2e_of_N2O_per_unit)) ? 'Factor to calculate total CO2e' : 'Factor to calculate CO2e of CO2'"></i></span><input :id="'co2_' + itemIndex + '_' + activityDatumId" type="number" class="form-control co2-input" :value="calculations[activityDatumId].kg_CO2e_of_CO2_per_unit" disabled></td>
              <td><span v-show="!isNaN(calculations[activityDatumId].kg_CO2e_of_CH4_per_unit)"><span>kg CH4 per unit&nbsp;<i class="icomoon-info" title="Factor to calculate CO2e of CH4"></i></span><input :id="'ch4_' + itemIndex + '_' + activityDatumId" type="number" class="form-control ch4-input" :value="calculations[activityDatumId].kg_CO2e_of_CH4_per_unit" disabled></span></td>
              <td><span v-show="!isNaN(calculations[activityDatumId].kg_CO2e_of_N2O_per_unit)"><span>kg N2O per unit&nbsp;<i class="icomoon-info" title="Factor to calculate CO2e of N2O"></i></span><input :id="'n2o_' + itemIndex + '_' + activityDatumId" type="number" class="form-control n2o-input" :value="calculations[activityDatumId].kg_CO2e_of_N2O_per_unit" disabled></span></td>
            </tr>
          </table>
        </div>
        <ul class="no-bullets" v-show="isOpen" v-if="isFolder">
          <ghg-tree-item
            class="tree-item"
            v-for="(child, index) in item.children"
            :key="index"
            :item="child"
            :item-index="parseInt(index)"
            :root-item-index="rootItemIndex"
            :calculations="calculations"
            :filter="filter"
            @ghgInput="emitGhgInputEvent"
          ></ghg-tree-item>
        </ul>
        <div v-if="item.footnote" class="mb-4 text-muted">{{ item.footnote }}</div>
    </li>
</template>
<script>
export default {
  name: "ghg-tree-item",
  props: {
    item: Object,
    calculations: Object,
    itemIndex: Number,
    rootItemIndex: Number,
    filter: String
  },
  data () {
    return {
      isOpen: true,
      isOpenActivityData: true
    };
  },
  computed: {
    isFolder () {
      return this.item.children && Object.keys(this.item.children).length > 0;
    },
    hasActivityData () {
      return this.item.activityData && this.item.activityData.length > 0;
    },
  },
  methods: {
    toggle () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    toggleActivityData () {
      if (this.hasActivityData) {
        this.isOpenActivityData = !this.isOpenActivityData;
      }
    },
    emitGhgInputEvent(value, itemIndex, activityDatumId, co2, ch4, n2o, rootItemIndex) {
      if (co2 === null) {
        co2 = document.getElementById('co2_' + itemIndex + '_' + activityDatumId).value;
      }
      if (ch4 === null) {
        ch4 = document.getElementById('ch4_' + itemIndex + '_' + activityDatumId).value;
      }
      if (n2o === null) {
        n2o = document.getElementById('n2o_' + itemIndex + '_' + activityDatumId).value;
      }
      this.$emit('ghgInput', value, itemIndex, activityDatumId, co2, ch4, n2o, rootItemIndex);
    },
    missingCH4N2O (ch4, n2o) {
      return isNaN(ch4) && isNaN(n2o)
    }
  }
};
</script>
<style scoped>
ul.no-bullets {
  list-style-type: none;
  padding-left: 20px;
  margin: 0;
}
.toggle-tree-item {
  cursor: pointer;
  margin-right: 5px;
}
.icomoon-info {
  cursor: help;
}
</style>
